import {
  DesignTokenSizeEnum,
  Text,
  TokenTextAppearance,
  TokenTextColor,
  TextTag,
} from '@volkswagen-onehub/components-core';
import type { HTMLAttributes, ReactNode } from 'react';
import { PillInner, PillWrapper } from './Pill.styles';
import Box from '../Box/Box';

export type PillIconPosition = 'start' | 'end';

export interface PillProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
  icon?: JSX.Element;
  iconPosition?: PillIconPosition;
}

const Pill = ({
  children,
  icon,
  iconPosition = 'end',
  onClick,
  ...restProps
}: PillProps) => {
  return (
    <PillWrapper onClick={onClick} {...restProps}>
      <PillInner iconPosition={iconPosition}>
        {children && (
          <Box
            as={Text}
            appearance={TokenTextAppearance.copy100}
            color={TokenTextColor.inherit}
            tag={TextTag.span}
            whiteSpace='nowrap'
            bold
            mt={DesignTokenSizeEnum.static0}
          >
            {children}
          </Box>
        )}
        {icon}
      </PillInner>
    </PillWrapper>
  );
};

export default Pill;
